import React from 'react';
import {
  FileField,
  Show,
  ShowProps,
  SimpleShowLayout,
  useShowController,
  useTranslate,
} from 'react-admin';

import { Divider } from '@material-ui/core';
import UserDataBlock from '../../../components/UserDataBlock';
import TestHistory from '../../../components/TestHistory';
import ImmunotherapyAnswers from '../../../components/ImmunotherapyAnswers';
import ImmunotherapyForm from '../../../components/ImmonotherapyForm';

import './styles.scss';

const ReviewedImmunotherapyTestShow = (props: ShowProps) => {
  const {
    record,
    // error,
    // loading
  } = useShowController(props);
  const translate = useTranslate();

  return (
    <Show {...props}>
      <>
        <UserDataBlock record={record} />
        <Divider className="divider" />
        <ImmunotherapyAnswers hideLabReport />
        <Divider className="divider" />
        <SimpleShowLayout record={record}>
          <TestHistory record={record} />
          <FileField
            target="_blank"
            className="text--purple"
            source="labReport"
            title={translate('testResults.openLabReport')}
            label="immunotherapy.patient.labReport"
          />
        </SimpleShowLayout>
        <Divider className="divider" />
        <ImmunotherapyForm data={record} readonly />
      </>
    </Show>
  );
};

export default ReviewedImmunotherapyTestShow;
